







































































































































































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../../RestClient";
import DemoServer from "../../../shared/DemoServer";

import DateFormatter from "../../../shared/DateFormatter";
import Loading from "../../general/Loading.vue";
import PointerMenu from "../../general/PointerMenu.vue";
import ImageSelectBase64 from "../../general/ImageSelectBase64.vue";
import OverlayPictureViewer from "../../general/OverlayPictureViewer.vue";
import ApprovalList from "../../../components/controls/ApprovalList.vue";

import { SettingsPublicJson } from "../../../shared/SettingsJson";
import ClientJson, { defaultClientJson } from "../../../shared/ClientJson";
import { ClientStatus, ClientStatusNames } from "../../../shared/ClientStatus";
import { AccountStatus, AccountStatusNames } from "../../../shared/AccountStatus";
import ContactJson, { defaultContactJson } from "../../../shared/ContactJson";
import MailingRecipientJson, { defaultMailingRecipientJson } from "../../../shared/MailingRecipientJson";
import MailingListJson from "../../../shared/MailingListJson";
import { MailingRecipientStatus, MailingRecipientStatusNames } from "../../../shared/MailingRecipientStatus";
import SepaMandateJson from "../../../shared/SepaMandateJson";
import { Gender } from "../../../shared/Gender";
import { CreatedBy } from "../../../shared/CreatedBy";

import { UserPermissionRank } from "../../../shared/UserPermissionRank";
import ModulesJson, { checkModuleIsActivated } from "../../../shared/ModulesJson";

import { ValidationResult, Validation } from "../../../shared/Validation";
import { validateClientJson, validateClientJsonAddNew, validateClientJsonRequest } from "../../../shared/ClientJson";
import FormContact from "../../../components/general/FormContact.vue";
import FormSepaMandate from "../../../components/general/FormSepaMandate.vue";

import CustomContent from "../../../components/custom/AccountRegistration";

export default Vue.extend({
  name: "ClientsAccountDetails",
  components: {
    Loading,
    PointerMenu,
    FormContact,
    FormSepaMandate,
    ImageSelectBase64,
    OverlayPictureViewer,
    ApprovalList,
  },
  props: {
    settings: Object as PropType<SettingsPublicJson | null>,
    activeModulesCheck: Object,
    clientDetails: Object as PropType<ClientJson | null>,
    password: String,
    detailsMode: {
      type: String,
      default: "read",
    },
  },
  data() {
    return {
      RestClient: RestClient,
      DemoServer: DemoServer,
      DateFormatter: DateFormatter,
      Gender: Gender,
      CustomContent: CustomContent,
      ClientStatus: ClientStatus,
      ClientStatusNames: ClientStatusNames,
      AccountStatus: AccountStatus,
      AccountStatusNames: AccountStatusNames,
      MailingRecipientStatus: MailingRecipientStatus,
      MailingRecipientStatusNames: MailingRecipientStatusNames,
      CreatedBy: CreatedBy,
      checkModuleIsActivated: checkModuleIsActivated,
      supportsDatePicker: false,
      mode: "" as string,
      editable: false as boolean,
      details: null as ClientJson | null,
      allMailingLists: null as MailingListJson[] | null,
      useMailings: false as Boolean,
      useAccount: true as Boolean,
      useSepaMandate: false as boolean,
      hidePassword: true as boolean,
      newPassword: "" as string,
      overlayPictureViewerImgUrl: null as string | null,
      hasChanges: false,
      hintChanged: {
        state: false as boolean,
      },
      frontendValidations: {
        username: false,
        password: false,
      },
      usernameTimeout: null as any,
      toValidate: {} as any,
      validation: null as ValidationResult<ClientJson> | null,
      submitValidation: false as boolean,
      loadingGeneral: false as boolean,
      loadingUsernameAvailability: false as boolean,
      loadingRequest: false as boolean,
      loadingResend: false as boolean,
      loadingDelete: false as boolean,
      loadingConfirm: false as boolean,
    };
  },
  created() {
    this.initDetails();
  },
  mounted() {
    this.checkDatePickerSupport();
  },
  methods: {
    async initDetails() {
      this.mode = this.detailsMode;
      this.details = this.clientDetails;
      if (this.details == null) {
        this.details = { ...this.getDefaultClientData() };
      }

      this.details.mailingRecipient ? (this.useMailings = true) : (this.useMailings = false);
      this.details.sepaMandate ? (this.useSepaMandate = true) : (this.useSepaMandate = false);

      this.selectDetailsMode(this.mode);
      await this.loadMailingLists();
    },

    setCachedData() {
      this.$nextTick(() => {
        this.hasChanges = false;
      });
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    async loadMailingLists() {
      try {
        this.allMailingLists = await this.RestClient.getMailingListsSignUpPublic();
      } catch (e) {
        alert(e.message);
      }
    },

    getDefaultClientData(): ClientJson {
      return defaultClientJson();
    },

    getDefaultContact(): ContactJson {
      return defaultContactJson();
    },

    getDefaultSepaMandate(): SepaMandateJson {
      return {
        ID: null,
        dateTime: new Date().toISOString(),
        lastUseDateTime: new Date().toISOString(),
        accountHolderFirstName: this.details && this.details.contact ? this.details.contact.firstName : "",
        accountHolderLastName: this.details && this.details.contact ? this.details.contact.lastName : "",
        addressStreet: this.details && this.details.contact ? this.details.contact.addressStreet : "",
        addressZip: this.details && this.details.contact ? this.details.contact.addressZip : "",
        addressCity: this.details && this.details.contact ? this.details.contact.addressCity : "",
        addressCountry: this.details && this.details.contact ? this.details.contact.addressCountry : "",
        IBAN: "",
        BIC: "",
      };
    },

    //START set cached data

    //END set cached data

    resetHintChanged() {
      let k = this.hintChanged;
      let i: keyof typeof k;

      for (i in this.hintChanged) {
        this.hintChanged[i] = false;
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.details != null) {
        this.validation = validateClientJsonRequest(this.details);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    /* START frontend validation */

    async frontendValidation() {
      await this.checkUsernameAvailability();
      this.validatePassword();
    },

    async checkUsernameAvailability() {
      this.loadingUsernameAvailability = true;
      clearTimeout(this.usernameTimeout);

      let vue = this;

      this.usernameTimeout = setTimeout(async function () {
        if (vue.details != null && vue.details.username != null && vue.details.username != "") {
          try {
            let availability: boolean = await vue.RestClient.getUsernameAvailability(vue.details.username);
            vue.frontendValidations.username = !availability;
            vue.loadingUsernameAvailability = false;
          } catch (err) {
            alert(err.message);
            vue.loadingUsernameAvailability = false;
          }
        } else {
          vue.frontendValidations.username = false;
          vue.loadingUsernameAvailability = false;
        }
      }, 600);
    },

    validatePassword() {
      if (this.useAccount && this.newPassword == "") {
        this.frontendValidations.password = true;
      } else {
        this.frontendValidations.password = false;
      }
    },

    checkFrontendValidations() {
      let check = true;

      let k = this.frontendValidations;
      let i: keyof typeof k;
      for (i in this.frontendValidations) {
        if (this.frontendValidations[i] == true) {
          check = false;
        }
      }

      return check;
    },

    /* END frontend validation */

    toggleUseMailings() {
      if (this.details != null) {
        if (this.useMailings) {
          this.details.mailingRecipient = null;
          this.useMailings = false;
        } else {
          this.loadMailingLists();
          this.details.mailingRecipient = defaultMailingRecipientJson();
          this.details.mailingRecipient!.mailingLists = [];
          this.useMailings = true;
        }
      }
    },

    toggleUseAccount() {
      if (this.details != null) {
        if (this.useAccount) {
          this.details.username = null;
          this.useAccount = false;
        } else {
          this.details.username = "";
          this.newPassword = "";
          this.useAccount = true;
        }
      }
    },

    toggleUseSepaMandate() {
      if (this.details != null) {
        if (this.useSepaMandate) {
          this.details.sepaMandate = null;
          this.useSepaMandate = false;
        } else {
          this.details.sepaMandate = this.getDefaultSepaMandate();
          this.useSepaMandate = true;
        }
      }
    },

    stopEditMode() {
      if (!this.hasChanges) {
        this.selectDetailsMode("show");
        this.hasChanges = false;
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.selectDetailsMode("show");
          this.hasChanges = false;
        } else {
          //do nothing
        }
      }
    },

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    selectDetailsMode(mode: string) {
      this.resetHintChanged();

      switch (mode) {
        case "add":
          this.mode = "add";
          this.editable = true;
          break;

        case "edit":
          this.mode = "edit";
          this.editable = true;
          break;

        default:
          this.mode = "read";
          this.editable = false;
          break;
      }
    },

    toggleEditMode() {
      this.editable = !this.editable;
    },

    addRelative() {
      if (this.details != null) {
        if (this.details.relatives == null) {
          this.details.relatives = [];
        }
        this.details.relatives.push(this.getDefaultContact());
      }
    },

    deleteRelative(index: number) {
      if (this.details != null && this.details.relatives != null) {
        this.details.relatives.splice(index, 1);

        delete this.toValidate["relative-" + index];
      }
    },

    async resendClientConfirmTokenMail() {
      if (this.details != null && this.details.username != null && this.password != "") {
        this.loadingResend = true;

        try {
          await this.RestClient.resendClientConfirmTokenMail(this.details.username, this.password);
          alert("Es wurde eine neue E-Mail verschickt.");
          this.loadingResend = false;
        } catch (e) {
          this.loadingResend = false;
          alert(e.message);
        }
      }
    },

    //not in use
    async confirmClient() {
      if (this.details != null && this.details.username != null && this.password != "") {
        this.loadingConfirm = true;

        try {
          await this.RestClient.confirmClient(this.details.username, this.password);
          if (this.details != null) {
            this.loadingConfirm = false;
            this.$emit("change", this.details);
            alert("Der Account wurde erfolgreich bestätigt.");
          }
        } catch (e) {
          this.loadingConfirm = false;
          alert(e.message);
        }
      }
    },

    async requestClient() {
      if (this.details != null) {
        this.loadingRequest = true;
        this.submitValidation = true;

        this.validation = validateClientJsonRequest(this.details);
        await this.frontendValidation();

        if (
          (this.$refs.approvalRequired as any).validate() &&
          this.validation != null &&
          this.validation.isValid == true &&
          this.details.username != null &&
          this.checkFrontendValidations()
        ) {
          try {
            await this.RestClient.requestClient(this.details, this.newPassword);
            if (this.details != null) {
              alert("Die Daten wurden erfolgreich hinzugefügt.");
              this.details = null;
              this.$emit("change", undefined);
              this.loadingRequest = false;
              this.logout();
            }
          } catch (e) {
            this.loadingRequest = false;
            alert(e.message);
          }
        } else {
          this.loadingRequest = false;
          //todo Validation Error anzeigen
          alert("Die Daten konnte nicht hinzugefügt werden. Bitte überprüfen Sie Ihre Angaben.");
        }
      }
    },

    async saveClientDetails() {
      if (this.details != null && this.details.username != null && this.password != "") {
        if (this.hasChanges) {
          this.loadingGeneral = true;
          this.submitValidation = true;

          //todo ###START
          //todo: Validation muss durchgeführt werden (siehe hier) ->AUCH bei SettingsDetails
          this.validation = validateClientJson(this.details);
          //todo ###END

          if (this.validation != null && this.validation.isValid == true && this.checkFrontendValidations()) {
            if (this.details.username != null && this.newPassword != "") {
              await this.changePassword();
            }

            try {
              let updatedDetails = await this.RestClient.updateOwnClient(
                this.details,
                this.details.username,
                this.password
              );

              this.hasChanges = false;
              this.loadingGeneral = false;
              this.submitValidation = false;
              this.stopEditMode();

              //TODO: Validation error loest alert auch aus -> prüfen
              alert("Die Änderungen wurden erfolgreich gespeichert.");
            } catch (e) {
              this.loadingGeneral = false;
              alert(e.message);
            }
          } else {
            this.loadingGeneral = false;
            alert("Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen.");
          }
        } else {
          alert("Es wurden keine Änderungen vorgenommen.");
        }
      }
    },

    async deleteClient() {
      if (this.details != null && this.details.username != null) {
        this.loadingDelete = true;

        var confirmText = "Wollen Sie diese Daten wirklich unwiderruflich löschen?";
        if (this.details.createdBy == CreatedBy.management) {
          confirmText =
            "Der Account wurde durch die Verwaltung erstellt. Sie können daher nur Ihren Zugang löschen. Wollen Sie diesen wirklich löschen?";
        }

        let c = confirm(confirmText);
        if (c == true) {
          try {
            await this.RestClient.deleteOwnClient(this.details.username, this.password);
            alert("Die Daten wurden erfolgreich gelöscht.");
            this.loadingDelete = false;
            this.logout();
          } catch (e) {
            this.loadingDelete = false;
            alert(e.message);
          }
        } else {
          this.loadingDelete = false;
          //do nothing
        }
      }
    },

    async changePassword() {
      if (this.details != null && this.details.username != null) {
        try {
          await this.RestClient.clientChangeOwnPassword(this.newPassword, this.details.username, this.password);

          this.$emit("changePassword", this.newPassword);
        } catch (e) {
          alert(e.message);
        }
      }
    },

    logout() {
      this.$emit("logout");
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    detailsMode() {
      this.selectDetailsMode(this.detailsMode);
    },

    details: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },
  },

  computed: {
    getRecipientMailingListNames(): string | undefined {
      if (
        this.details != null &&
        this.details.mailingRecipient != null &&
        this.details.mailingRecipient.mailingLists != null
      ) {
        let mailingListNames = [];

        for (let i = 0; i < this.details.mailingRecipient.mailingLists.length; i++) {
          mailingListNames.push(this.details.mailingRecipient.mailingLists[i].name);
        }

        if (mailingListNames.length <= 0) {
          return "Keiner Liste zugeordnet";
        } else {
          return mailingListNames.join(", ");
        }
      }
    },

    username: {
      get(): string | null | undefined {
        if (this.details != null) {
          return this.details.username;
        }
      },
      set(value: string) {
        if (this.details != null) {
          if (value == "") {
            this.details.username = null;
          } else {
            this.details.username = value;
          }
        }
      },
    },
  },
});
